export const SELECT_DROPDOWN_SELECT_ALL_VALUE = 'BNC_SELECT_DROPDOWN_SELECT_ALL';
export const SELECT_DROPDOWN_SELECT_ALL_LABEL = 'Select all';
//# sourceMappingURL=index.js.map